import { Search, Sorting, Pagination } from '@/types';

export interface ListFilters extends Search, Sorting, Pagination {}
